import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EnumerationService } from './enumeration.service';
import { Entity, EnumerationClass } from '@common/types';

@Component({
    selector: 'enumerations-class-list-item',
    templateUrl: './enumerations-class-list-item.component.html',
})
export class EnumerationsClassListItemComponent {
    @Input() enumerationClasses: Entity<EnumerationClass & { isSelected?: boolean }>[] = [];
    @Input() facetPrivilege: string;
    @Output() classRemoved: EventEmitter<Entity<EnumerationClass>> = new EventEmitter<Entity<EnumerationClass>>();
    @Output() classSelected: EventEmitter<Entity<EnumerationClass>> = new EventEmitter<Entity<EnumerationClass>>();

    constructor(
        private enumerationService: EnumerationService,
    ) {
    }

    isSafeToDeleteEnumClass(enumClass: Entity<EnumerationClass>): boolean {
        return (
            enumClass.EnumerationItem.length === 0 &&
            enumClass.Input.length === 0 &&
            enumClass.Output.length === 0 &&
            enumClass.TaxonCharacteristic.length === 0 &&
            enumClass.SampleCharacteristic.length === 0 &&
            enumClass.JobCharacteristic.length === 0 &&
            enumClass.StudyCharacteristic.length === 0);
    }

    removeClass(enumerationClass: Entity<EnumerationClass>): void {
        this.enumerationService.deleteClass(enumerationClass);
        const index = this.enumerationClasses.indexOf(enumerationClass);

        this.enumerationClasses.splice(index, 1);

        this.classRemoved.emit(enumerationClass);
    }

    selectClass(enumerationClass: Entity<EnumerationClass & { isSelected?: boolean }>): void {
        this.classSelected.emit(enumerationClass)
    }

}
